import { CrudButton } from "../../components/CrudButton"
import { authProvider } from '../../utilities';
export default function Login() {
  return (
   <>
    <CrudButton className="btn  btn-primaryCustom mt-1 w-100" icon="bi bi-box-arrow-in-right" text="Iniciar Sesión" onClick={authProvider.login} />
   </>
  )
}
